<template>
  <v-layout class="criterio-time-range">
    <v-row>
      <v-col col="6">
        <v-row>
          <v-col class="py-0">
            <time-picker
              :time.sync="initTime"
              :disabled="disabled"
              outline
              label="De"
              class="default-input"
              :use-minutes="false"
              hide-details
              @input="input(true)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <span :class="spanClass" @click="clearInitTime">Remover seleção</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col col="6">
        <v-row>
          <v-col class="py-0">
            <time-picker
              :time.sync="endTime"
              :disabled="disabled"
              :min="initTime"
              outline
              label="Até"
              class="default-input"
              :use-minutes="false"
              hide-details
              force-last-minute
              @input="input(false)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <span :class="spanClass" @click="clearEndTime">Remover seleção</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import TimePicker from '@/components/TimePicker.vue'

export default {
  components: {
    TimePicker,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    initTime: null,
    endTime: null,
  }),

  computed: {
    ...mapState({}),

    spanClass() {
      return this.disabled ? 'disabled' : 'link-erro'
    },
  },

  mounted() {
    this.formatInitialValues()
    this.validate()
  },

  methods: {
    input(isInitialTime) {
      if (isInitialTime) this.endTime = null

      let initTimeToSave = false
      let endTimeToSave = false
      if (this.initTime) {
        initTimeToSave = parseInt(this.initTime.slice(0, 2))
      }
      if (this.endTime) {
        endTimeToSave = parseInt(this.endTime.slice(0, 2))
      }

      this.$emit('input', { currentValue: [initTimeToSave, endTimeToSave], currentIndex: this.currentIndex })

      this.validate()
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.initTime !== null || this.endTime !== null)
    },

    formatInitialValues() {
      if (this.initialValue?.[0]) this.initTime = `${this.initialValue?.[0]}:00`
      if (this.initialValue?.[1]) this.endTime = `${this.initialValue?.[1]}:59`
    },
    clearInitTime() {
      if (!this.disabled) {
        this.initTime = null
        this.input()
      }
    },
    clearEndTime() {
      if (!this.disabled) {
        this.endTime = null
        this.input()
      }
    },
  },
}
</script>

<style lang="scss">
.criterio-time-range {
  .input-container {
    margin-right: 15px;
  }
}

.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
